module.exports = __webpack_public_path__ + "img/malbec-syrah.22ef0d67.jpg";